<template>
  <div class="page" v-loading="listLoading">
    <div class="toolbox">
      <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
    </div>
    <el-form @submit.native.prevent label-width="90px" class="mgt20">
      <el-row>
        <el-col :span="6">
          <el-form-item label="商品Id">
            <el-input v-model="ProductId" placeholder="商品Id" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="外部SpuId">
            <el-input v-model="RemoteSpuId" placeholder="外部SpuId" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="外部SkuId">
            <el-input v-model="RemoteID" placeholder="外部SkuId" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品名称">
            <el-input v-model="ProductName" placeholder="商品名称" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="商品品牌">
            <el-autocomplete class="w100" v-model="brandName" :fetch-suggestions="querySearchAsync" placeholder="商品品牌"
              @select="handleSelect" clearable @clear="clearBtn"></el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品型号">
            <el-input v-model="ProductModel" placeholder="商品型号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品类型">
            <el-cascader class="w100" v-model="CategoryId" :props="{ emitPath: false, checkStrictly: true }"
              :show-all-levels="false" :options="productNavTypeTreeList" placeholder="商品类型" clearable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建日期">
            <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至" start-placeholder="创建时间" end-placeholder="结束时间" @change="handlePicker" class="w100">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="供应商">
            <el-select v-model="SupplierId" placeholder="供应商" style="width:100%;">
              <el-option v-for="(item, index) in supplierList" :key="index" :label="item.value"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="分销商">
            <el-select v-model="ResellerId" filterable remote :remote-method="remoteReseller" placeholder="分销商"
              style="width:100%;">
              <el-option v-for="(item, index) in resellerList" :key="index" :label="item.value"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="审核状态">
            <el-select v-model="RemoteShelvesAuditStatus" placeholder="审核状态" style="width:100%;">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="待提交" :value="0"></el-option>
              <el-option label="待审核" :value="1"></el-option>
              <el-option label="审核通过" :value="2"></el-option>
              <el-option label="审核不通过" :value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="4">
          <el-form-item label="上下架状态">
            <el-select v-model="IsShelves" placeholder="上下架状态" style="width:100%;">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="上架" :value="true"></el-option>
              <el-option label="下架" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item label="是否同步">
            <el-select v-model="IsPush" placeholder="请选择" style="width:100%;">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="flex">
              <el-button type="primary" @click="searchFun">查询</el-button>
              <el-button @click="resetFun">重置</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border 
      :row-class-name="tableRowClass">
      <el-table-column type="selection" width="70" fixed align="center"></el-table-column>
      <el-table-column prop="productId" label="SpuId" width="100" align="center"></el-table-column>
      <el-table-column prop="productSkuId" label="SkuId" width="100" align="center"></el-table-column>
      <el-table-column prop="remoteId" label="外部SkuId" width="120" align="center"></el-table-column>
      <el-table-column prop="remoteSpuId" label="外部SpuId" width="120" align="center"></el-table-column>
      <el-table-column prop="saleableSkuId" label="销售skuid" width="100" align="center"></el-table-column>
      <el-table-column prop="productName" label="商品名称" align="center" min-width="300"></el-table-column>
      <el-table-column prop="supplyPrice" label="供货价" width="120" align="center"></el-table-column>
      <!-- <el-table-column prop="remoteSupplyPrice" label="营客通采购价" width="120" align="center"></el-table-column> -->
      <!-- <el-table-column prop="merchantsPrice" label="商家价" width="120" align="center"></el-table-column> -->
      <el-table-column prop="" label="营客通商家价" width="120" align="center"  v-if="isShowPrice">
        <template slot-scope="scope">
          <span :style="{'color':scope.row.remoteMerchantsPrice < scope.row.supplyPrice ?'red':'#606266'}">{{ scope.row.remoteMerchantsPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品规格" align="center" min-width="300">
        <template slot-scope="scope">{{
          scope.row.propertyDisplayExt ? scope.row.propertyDisplayExt : scope.row.propertyDisplay }}</template>
      </el-table-column>
      <el-table-column prop="brandName" label="商品品牌" width="120" align="center"></el-table-column>
      <el-table-column label="商品型号" prop="productModel" width="120" align="center"></el-table-column>
      <el-table-column prop="categoryName" label="商品类型" width="120" align="center"></el-table-column>
      <el-table-column prop="creationTime" label="创建时间" width="200" align="center"></el-table-column>
      <el-table-column prop="supplierName" label="供应商" width="120" align="center"></el-table-column>
      <el-table-column prop="resellerName" label="分销商" width="120" align="center"></el-table-column>
      <el-table-column prop="isPush" label="同步状态" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.isPush ? '已同步' : '未同步' }}</template>
      </el-table-column>
      <el-table-column label="审核状态" width="120" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.remoteShelvesAuditStatus == 0">待提交</span>
          <span v-if="scope.row.remoteShelvesAuditStatus == 1">待审核</span>
          <span v-if="scope.row.remoteShelvesAuditStatus == 2">审核通过</span>
          <span v-if="scope.row.remoteShelvesAuditStatus == 3">审核不通过</span>
        </template>
      </el-table-column>
      <el-table-column prop="remoteNote" label="审核反馈" width="120" align="center"></el-table-column>
      <el-table-column prop="isShelves" label="上下架状态" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.isShelves ? '上架' : '下架' }}</template>
      </el-table-column>
      <el-table-column prop="" label="营客通上下架状态" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.remoteIsShelves ? '上架' : '下架' }}</template>
      </el-table-column>

      <!-- 
      <el-table-column label="商品图片" width="150" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.imageUrl" width="120" alt="暂无" @click="handleLookBigPic(scope.row.imageUrl)" />
        </template>
      </el-table-column>
      <el-table-column prop="stock" label="库存总量" width="120" align="center"></el-table-column>
      <el-table-column prop="lastModificationTime" label="最近操作时间" width="200" align="center"></el-table-column> -->
      <el-table-column width="150" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button class="mgb10" size="mini" v-for="(item, index) in buttonList_table" :key="index"
            :type="item.buttonType" @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
          </el-button>
          <!-- <el-button class="mgb10" size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleOnShelve(scope.row)">同步并上架</el-button>
          <el-button size="mini" type="success" @click="handleOffShelve(scope.row)">同步并下架</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" v-if="isShowPage" layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" :total="total"
      :page-sizes="[10, 20, 30, 40, 50, 100]"></el-pagination>
  </div>
</template>

<script>
import {
  ProductSkuGetManyList,
  GetProductList,
  ProductDelete,
  brandGetAll,
  CategoryGetTree,
  SupplierGetAll,
  GetAllReseller,
  ProductSync,
  UpdateShelvesMany,
  ExportManyList
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";
// import IScroll from 'iscroll/build/iscroll-probe'
import IScroll from 'iscroll/build/iscroll-probe'
export default {
  components: { Toolbar },
  data() {
    return {
      isShowPage: true,
      ProductId: null,
      RemoteID: null,
      RemoteSpuId: null,
      RemoteShelvesAuditStatus: null,
      IsPush: null,
      ProductName: null, //商品名称
      ProductModel: null, //商品型号
      CategoryId: null, //商品类型
      BrandId: null, //品牌
      StartCreationTime: null,
      EndCreationTime: null,
      ResellerId: null,
      SupplierId: null,
      IsShelves: false,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      valueTime: [],
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      brandName: '',
      tableList: [],
      productNavTypeTreeList: [],
      supplierList: [],
      resellerList: [],
      SourceType: 0, // 0 自有  1 供应商
      SourceId: null,
      SelectedButton: -1,
      CurrentSourceId: null,
      CurrentSourceType: 0,
      isShowPrice: false
    };
  },
  watch: {
    ResellerId: {
      handler(n, o) {
        if (n) {
          let t = this.resellerList.find(i => i.id === n)
          if (t) {
            this.isShowPrice = t.supType === 2
          } else {
            this.isShowPrice = false
          }
        } else {
          this.isShowPrice = false
        }
      },
      immediate: true
    }
  },
  created() {
    this.getProductNavTypeTree();
    this.getBrandList();
    this.getSupplierList();
    this.getResellerId()
    // this.getAllReseller()
  },
  mounted() {
    // const myScroll = new IScroll('#scroll', {
    //   //按照需求添加横向滚动的配置项
    // });
    //更新
    // console.log('myScroll',myScroll)
    // myScroll.refresh();

    // this.getSpusOnSale();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      console.log(toolBarButtonList, 'toolBarButtonList')
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
  methods: {
    fastUpdate() {
      this.$router.push('/Product/ComManagement/FastModify')
    },
    exportBtn() {
      let that = this;
      let para = {
        ResellerId: that.ResellerId, // 分销商
        SupplierId: that.SupplierId,
        ProductId: that.ProductId,
        RemoteShelvesAuditStatus: that.RemoteShelvesAuditStatus,
        IsPush: this.IsPush,
        IsShelves: that.IsShelves,
        RemoteID: that.RemoteID,
        RemoteSpuId: that.RemoteSpuId,
        ProductName: that.ProductName, //商品名称
        ProductModel: that.ProductModel, //商品型号
        CategoryId: that.CategoryId, //商品类型
        BrandId: that.BrandId, //品牌
        StartCreationTime: that.StartCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
      };
      ExportManyList(para).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '商品列表数据.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    batchShelves() {
      if (!this.currentRow[0]) {
        return this.$message.error("请选择需要操作的商品");
      }
      let list = []
      this.currentRow.forEach(item => {
        list.push({
          isShelves: true,
          isPush: true,
          saleableSkuId: item.saleableSkuId
        })
      })
      let params = {
        resellerId: this.ResellerId,
        items: list
      };
      this.listLoading = true;
      UpdateShelvesMany(params).then((res) => {
        this.listLoading = false;
        if (res.data.success) {
          if (res.data.result) {
            this.$message.success(res.data.result);
          } else {
            this.$message.success('同步并上架');
          }
          this.getSpusOnSale();
        } else {
          this.$message.error(res.error.message);
        }
      })
    },
    handleOnShelve(item, index, row) {
      let params = {
        resellerId: row.resellerId,
        items: [{
          isShelves: true,
          isPush: true,
          saleableSkuId: row.saleableSkuId
        }]
      };
      this.listLoading = true;
      UpdateShelvesMany(params).then((res) => {
        this.listLoading = false;
        if (res.data.success) {
          if (res.data.result) {
            this.$message.success(res.data.result);
          } else {
            this.$message.success('同步并上架');
          }
          this.getSpusOnSale();
        } else {
          this.$message.error(res.error.message);
        }
      })
    },
    handleOffShelve(item, index, row) {
      let params = {
        resellerId: row.resellerId,
        items: [{
          isShelves: false,
          isPush: true,
          saleableSkuId: row.saleableSkuId
        }]
      };
      this.listLoading = true;
      UpdateShelvesMany(params).then((res) => {
        this.listLoading = false;
        if (res.data.success) {
          if (res.data.result) {
            this.$message.success(res.data.result);
          } else {
            this.$message.success('同步并下架');
          }
          this.getSpusOnSale();
        } else {
          this.$message.error(res.error.message);
        }
      })
    },
    getResellerId() {
      GetAllReseller({ SkipCount: 0, MaxResultCount: 10 }).then(res => {
        if (res.data.success) {
          this.ResellerId = res.data.result.items[0].id
          this.resellerList = res.data.result.items.map((item) => {
            return {
              value: item.name,
              id: item.id,
              supType: item.supType
            };
          });
          this.getSpusOnSale();
        }
      })
    },
    remoteReseller(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100
      }
      if (key) {
        obj.Name = key;
      }
      return new Promise((resolve, reject) => {
        GetAllReseller(obj).then((res) => {
          this.isShowPage = true;
          // console.log('供应商列表', res);
          if (res.data.success) {
            this.resellerList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
                supType: item.supType
              };
            });
            // console.log('this.supplierList', this.supplierList)
            resolve(this.resellerList);
          } else {
            this.isShowPage = true;
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    getOwnProduct() {
      // console.log('自有')
      this.PageIndex = 1;
      this.PageSize = 10;
      this.SelectedButton = -1;
      this.CurrentSourceId = null;
      this.CurrentSourceType = 0;
      // this.SourceType = 0;
      // this.SourceId = null;
      this.getSpusOnSale();
    },
    getSupplierProduct(item, index) {
      this.SelectedButton = index;
      this.CurrentSourceId = item.id;
      this.CurrentSourceType = 1;
      // console.log('item', item)
      this.getSpusOnSale()
    },
    getSupplierList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.supplierName = key;
      }
      return new Promise((resolve, reject) => {
        SupplierGetAll(obj).then((res) => {
          this.isShowPage = true;
          // console.log('供应商列表', res);
          if (res.data.success) {
            this.supplierList = res.data.result.items.map((item) => {
              return {
                value: item.proSupplierName,
                id: item.id,
              };
            });
            // console.log('this.supplierList', this.supplierList)
            resolve(this.supplierList);
          } else {
            this.isShowPage = true;
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    deleteBtn(item, index, row) {
      let list = []
      list.push(row.productId)
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.getSpusOnSale()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    batchDelete() {
      if (!this.currentRow[0])
        return this.$message.error("请选择需要操作的商品");
      let list = this.currentRow.map((v) => {
        return v.productId
      });
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpusOnSale()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.BrandId = item.id;
    },
    clearBtn(val) {
      this.BrandId = null
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({ parentId: 0 }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    searchFun() {
      this.PageIndex = 1;
      this.getSpusOnSale();
    },
    handlePicker(e) {
      if (e == null) {
        this.valueTime = []
        this.StartCreationTime = e[0];
        this.EndCreationTime = e[1];
      } else {
        this.StartCreationTime = e[0];
        this.EndCreationTime = e[1];
      }
    },
    resetFun() {
      this.$nextTick(() => {
        this.isShowPage = false;
      })

      this.ProductId = null;
      this.RemoteID = null
      this.RemoteSpuId = null
      this.RemoteShelvesAuditStatus = null
      this.IsPush = null
      // this.IsShelves = null
      this.ProductName = null; //商品名称
      this.ProductModel = null; //商品型号
      this.SupplierId = null; //供应商
      this.CategoryId = null; //商品类型
      this.BrandId = null; //品牌
      this.PageIndex = 1; //页码
      this.PageSize = 10; //页长
      this.StartCreationTime = null;
      this.EndCreationTime = null;
      this.brandName = ''
      this.valueTime = []
      this.SelectedButton = -1
      this.CurrentSourceType = 0
      this.CurrentSourceId = null;
      this.getSpusOnSale();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.getSpusOnSale();
    },
    handleSizeChange(e) {
      this.PageSize = e;
      this.getSpusOnSale();
    },
    //获取商品列表
    getSpusOnSale() {
      let that = this;
      let para = {
        ResellerId: that.ResellerId, // 分销商
        SupplierId: that.SupplierId,
        ProductId: that.ProductId,
        RemoteShelvesAuditStatus: that.RemoteShelvesAuditStatus,
        IsPush: this.IsPush,
        IsShelves: that.IsShelves,
        RemoteID: that.RemoteID,
        RemoteSpuId: that.RemoteSpuId,
        ProductName: that.ProductName, //商品名称
        ProductModel: that.ProductModel, //商品型号
        CategoryId: that.CategoryId, //商品类型
        BrandId: that.BrandId, //品牌
        StartCreationTime: that.StartCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
        // SourceType: this.CurrentSourceType,
        // SourceId: this.CurrentSourceId,
      };
      // console.log('para', para)
      this.listLoading = true;
      ProductSkuGetManyList(para).then((res) => {
        setTimeout(() => {
          this.listLoading = false;
        }, 500)
        if (res.data.success) {
          if (res.data.result.items) {
            res.data.result.items.forEach(item => {
              item.IsSort = false
            })
          }
          this.total = res.data.result.totalCount;
          let list = res.data.result.items || [];
          list.forEach((item) => {
            if (item.remoteMerchantsPrice < item.supplyPrice) {
              item.highLight = true
            }
            if (!item.isPush) {
              item.pushHighLight = true
            }
            item.popoverVisible = false;
          });
          this.tableList = list;
          this.$nextTick(() => { 
            this.isShowPage = true;
          })
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    tableRowClass({ row, rowIndex}) {
      if (row.highLight && row.pushHighLight) {
        return 'highLight pushHighLight'
      } else if (row.highLight) {
        return 'highLight'
      } else if (row.pushHighLight) {
        return 'pushHighLight'
      } else {
        return ''
      }
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.productId}`)
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.toolbox {
  text-align: right;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
}

.mgb10 {
  margin-bottom: 10px;
}

.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap !important;
  overflow-x: auto;
}

/deep/ .el-scrollbar__wrap {
  height: calc(100% + 17px);
}

::-webkit-scrollbar-track-piece {
  background-color: #fff;
  -webkit-border-radius: 0
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px
}

::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #b8b8b8;
  -webkit-border-radius: 6px;
  outline: 2px solid #fff;
  outline-offset: -2px;
  border: 2px solid #fff;
  filter: alpha(opacity=50);
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  opacity: 0.5
}

::-webkit-scrollbar-thumb:hover {
  height: 50px;
  background-color: #878987;
  -webkit-border-radius: 6px
}
/deep/ .el-table .highLight {
  position: relative;
  &::after{
    content:'与商城价格不一致';
    display: block;
    font-size: 12px;
    height:20px;
    line-height: 20px;
    background-color: #ff3f3f;
    color:white;
    padding:0 7px;
    position: absolute;
    left:0;
    top:0;
    z-index: 100;
  }
}
/deep/ .el-table .pushHighLight>td:first-child{
  position: relative;
  &::after{
    content:'未同步';
    display: block;
    font-size: 12px;
    height:20px;
    line-height: 20px;
    background-color: #ff7028;
    color:white;
    padding:0 7px;
    position: absolute;
    left:0;
    top:20px;
    z-index: 100;
  }
}</style>
